// The festival in public (docs/plans/FESTIVALS.md Phase 6). No login.
// Shapes are utils/festivalPublic.ts, the server's festivalPublicPolicy.
import axios from 'axios';
import { getApiBaseUrl } from './apiConfig';
import type { PublicFestival } from '../utils/festivalPublic';

export type FestivalShareResult =
  | { stage: 'festival_ended'; festivalId: string }
  | { stage: 'ready'; festivalId: string; festival: PublicFestival };

export const publicFestivalApi = {
  /** The showliner.io page's read. A 404 means private, unknown or gone. */
  async get(festivalId: string): Promise<PublicFestival> {
    const res = await axios.get(`${getApiBaseUrl()}/api/public/festivals/${festivalId}`);
    return res.data;
  },

  /** The festival share link's read. A 404 means the link no longer works. */
  async resolveShare(token: string): Promise<FestivalShareResult> {
    const res = await axios.get(`${getApiBaseUrl()}/api/festival-share/${encodeURIComponent(token)}`);
    return res.data;
  },
};

export default publicFestivalApi;
